import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import RequestsListItem from '../RequestsListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="requestsView" itemLayout={RequestsListItem} />
	}
];

export default tabs;
